import React from "react";
import { useConfig } from "../context/ConfigContext";

export default function WhatsAppFloat() {
  const { whatsapp } = useConfig();
  const link = `https://wa.me/${whatsapp}?text=${encodeURIComponent(
    "Hi 5999Cargo, I would like a quote for shipping to Curaçao."
  )}`;
  return (
    <a
      data-testid="whatsapp-float-button"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 wa-pulse flex items-center gap-3 bg-[#25D366] hover:bg-[#1fb858] text-white pl-4 pr-5 py-3 rounded-full shadow-2xl transition-all duration-200 hover:scale-105"
      aria-label="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white" aria-hidden>
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.51 5.26l.6.953-1.005 3.67 3.787-.99.297.408z" />
        <path d="M9.43 6.92c-.224-.498-.46-.508-.673-.516a13.8 13.8 0 0 0-.572-.01c-.198 0-.52.075-.792.372-.273.297-1.04 1.016-1.04 2.479s1.065 2.875 1.213 3.074c.149.198 2.057 3.295 5.077 4.488 2.51.99 3.022.793 3.567.743.545-.05 1.758-.718 2.006-1.41.247-.694.247-1.288.173-1.412-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.867-2.03-.966-.272-.099-.47-.149-.668.149-.198.297-.767.966-.94 1.165-.173.198-.347.223-.644.075-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.479-1.762-1.652-2.06-.173-.297-.018-.458.13-.606.135-.135.297-.347.446-.521.149-.173.198-.297.297-.495.099-.198.05-.371-.025-.52-.074-.149-.65-1.61-.911-2.207z" />
      </svg>
      <span className="hidden sm:inline font-chivo font-bold text-sm tracking-wide">
        WhatsApp
      </span>
    </a>
  );
}
